import React from 'react';
import { Location, Navigate, BrowserRouter, Route, Routes, useLocation, useParams } from 'react-router-dom';
import LinkRedirect from './LinkRedirect';


export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/:userCode' element={<LinkRedirect/>}/>
            </Routes>
        </BrowserRouter>
    );
}